import React from 'react';
import { Card } from './ui/card';
import { Award } from 'lucide-react';
import '../styles/Certifications.css';

const Certifications = ({ data }) => {
  return (
    <section id="certifications" className="certifications-section">
      <div className="certifications-container">
        <div className="section-header">
          <h2 className="section-title">Certifications & Achievements</h2>
          <p className="section-subtitle">
            Recognized expertise in AI and data science
          </p>
        </div>

        <div className="certifications-grid">
          {data.map((cert, index) => (
            <Card key={index} className="certification-card">
              <div className="cert-icon">
                <Award className="award-icon" />
              </div>
              <div className="cert-content">
                <h3 className="cert-title">{cert.title}</h3>
                <p className="cert-issuer">{cert.issuer}</p>
                <span className="cert-year">{cert.year}</span>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certifications;